import SearchService from "../services/SearchService";
export default [
  {
    path: "/d/:departement",
    name: "getDepartmentByName",
    beforeEnter(routeTo, routeFrom, next) {
      SearchService.getSearchQueryFromDepartmentName(routeTo.params.departement)
        .then(response => {
          next({
            name: "home",
            query: {
              placeType: "department",
              ...response
            }
          });
        })
        .catch(() => next({ name: "home" }));
    }
  },
  {
    path: "/r/:region",
    name: "getRegionByName",
    beforeEnter(routeTo, routeFrom, next) {
      SearchService.getSearchQueryFromRegionName(routeTo.params.region)
        .then(response => {
          next({
            name: "home",
            query: {
              placeType: "region",
              ...response
            }
          });
        })
        .catch(() => next({ name: "home" }));
    }
  },
  {
    path: "/a/:administrative",
    name: "getAdministrativeByName",
    beforeEnter(routeTo, routeFrom, next) {
      SearchService.getSearchQueryFromAdministrativeName(
        routeTo.params.administrative
      )
        .then(response => {
          next({
            name: "home",
            query: {
              placeType: "administrative",
              ...response
            }
          });
        })
        .catch(() => next({ name: "home" }));
    }
  }
];
